//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'
// import { get } from 'lodash';


//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const selectore = (state) => state.userPreference;
//  -- Examples array selector --------

export const useUserPreference = () => {
    const selectedData = useSelector(selectore, shallowEqual)
   return selectedData;
}
